module.exports = __webpack_public_path__ + "img/Energetic Driver.ffba76a9.svg";